module.exports = __webpack_public_path__ + "img/sm.774020e.jpg";